// src/store/slices/user/selectors.ts

import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/store';

export const selectUserState = (state: RootState) => state.user;

export const selectUser = createSelector(selectUserState, (s) => s.user);
export const selectUserLoading = createSelector(selectUserState, (s) => s.loadingUser);
export const selectNotifications = createSelector(selectUserState, (s) => s.notifications);
export const selectNotificationsLoading = createSelector(selectUserState, (s) => s.loadingNotifications);
export const selectUserFieldErrors = createSelector(selectUserState, (s) => s.fieldErrors);
export const selectUserFieldError = (field: string) =>
  createSelector(selectUserState, (s) => s.fieldErrors[field]);
